(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diy-kit-copper-option"] && !Shopify.designMode) return;
  try {
    (() => {
  class DiyKitCopperOption extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.input = this.querySelector('[data-kit-copper]');
      if (!this.form || !this.input) return;
      this.abort = new AbortController();
      this.addEventListener('change', () => this.updateQuote(), { signal: this.abort.signal });
      requestAnimationFrame(() => this.updateQuote());
    }
    disconnectedCallback() { this.abort?.abort(); }
    updateQuote() {
      const line = this.dataset.line.replace('__THICKNESS__', this.input.value);
      for (const link of this.form.querySelectorAll('[data-pack-quote-link]')) {
        if (!link.dataset.kitCopperOriginal) link.dataset.kitCopperOriginal = link.getAttribute('href');
        const url = new URL(link.dataset.kitCopperOriginal);
        url.searchParams.set('subject', `${url.searchParams.get('subject')} · ${this.input.value} mm copper`);
        url.searchParams.set('body', [url.searchParams.get('body'), this.dataset.productTitle, line, this.dataset.note].filter(Boolean).join('\n'));
        link.setAttribute('href', url.toString());
      }
    }
  }
  if (!customElements.get('diy-kit-copper-option')) customElements.define('diy-kit-copper-option', DiyKitCopperOption);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drone-connector-option"] && !Shopify.designMode) return;
  try {
    (() => {
  const selections = new Map();
  const bare = 'Bare leads (no connector)';
  const fees = { 'XT90 installed': 700, 'XT60 installed': 500 };
  class DroneConnectorOption extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.preview = this.dataset.preview === 'true';
      this.quote = this.dataset.quote === 'true';
      this.cableIndex = Number(this.dataset.cablePosition) - 1;
      this.connectorIndex = Number(this.dataset.connectorPosition) - 1;
      this.key = this.form.getAttribute('id');
      this.variant = JSON.parse(this.querySelector('[data-connector-variant]').textContent || 'null');
      this.variants = JSON.parse(this.querySelector('[data-connector-variants]').textContent || '[]');
      const saved = selections.get(this.key);
      this.selection = this.preview || this.quote ? (saved?.connector || bare) : this.dataset.selected;
      this.cable = this.querySelector('[data-quote-cable]');
      if (this.cable) this.cable.value = saved?.cable || '';
      this.quoteLinks = Array.from(this.form.querySelectorAll('[data-pack-quote-link]'), link => ({ link, original: link.getAttribute('href') }));
      this.abort = new AbortController();
      const settings = { signal: this.abort.signal };
      this.addEventListener('change', event => this.choose(event), settings);
      this.form.addEventListener('change', event => {
        if (this.preview || this.quote || !event.target.matches('[data-option-position]')) return;
        event.stopImmediatePropagation();
        if (!this.pending) this.changeCombination();
      }, { ...settings, capture: true });
      for (const name of ['input', 'change']) {
        this.form.addEventListener(name, event => {
          if (event.target.name === 'quantity') this.render();
        }, settings);
      }
      this.form.addEventListener('variant:change', event => {
        this.variant = event.detail.variant;
        if (!this.preview) this.selection = this.variant?.options?.[this.connectorIndex] || bare;
        this.render();
      }, settings);
      this.form.addEventListener('product:rerender', () => {
        requestAnimationFrame(() => { if (this.isConnected) this.render(); });
      }, settings);
      this.form.addEventListener('click', event => this.guard(event), { ...settings, capture: true });
      this.form.addEventListener('submit', event => this.guard(event), { ...settings, capture: true });
      this.hidden = false;
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); }
    get twelveAwg() {
      const value = this.quote ? this.cable?.value : this.variant?.options?.[this.cableIndex];
      return /(?:^|\s\/\s)12\s*AWG(?:\s+cables)?$/i.test(value || '');
    }
    get selected() { return Object.hasOwn(fees, this.selection); }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.preview || this.quote ? 'USD' : this.dataset.currency }).format(cents / 100);
    }
    variantFor(connector) {
      if (this.connectorIndex < 0 || !this.variant?.options) return null;
      return this.variants.find(variant => variant.options.every((value, index) => index === this.connectorIndex ? value === connector : value === this.variant.options[index]));
    }
    optionText(input) {
      return input.tagName === 'OPTION' ? input.textContent.trim() : input.nextElementSibling?.getAttribute('title') || input.nextElementSibling?.textContent.trim() || '';
    }
    async changeCombination() {
      if (this.pending) return;
      const picker = this.form.querySelector('variant-picker');
      if (!picker?.selectCombination) {
        this.notice(this.dataset.unavailable);
        this.restoreOptions();
        this.render();
        return;
      }
      const optionValues = Array.from(this.form.elements)
        .filter(input => input.matches('input[data-option-position]:checked, input[data-option-position][type="hidden"], select[data-option-position]'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map(input => input.value);
      this.pending = true;
      this.notice('');
      this.render();
      try {
        await picker.selectCombination({ optionValues, productChange: false });
      } catch {
        this.restoreOptions();
        this.notice(this.dataset.unavailable);
      } finally {
        this.pending = false;
        if (this.isConnected) this.render();
      }
    }
    restoreOptions() {
      for (const input of this.form.querySelectorAll('[data-option-position]')) {
        const value = this.variant?.options?.[Number(input.dataset.optionPosition) - 1];
        if (input.tagName === 'SELECT') {
          const option = Array.from(input.options).find(item => this.optionText(item) === value);
          if (option) input.value = option.value;
        } else if (input.type === 'radio') {
          input.checked = this.optionText(input) === value;
        }
      }
    }
    save() { selections.set(this.key, { connector: this.selection, cable: this.cable?.value || '' }); }
    notice(message) {
      const node = this.querySelector('[data-connector-notice]');
      node.textContent = message;
      node.hidden = !message;
    }
    choose(event) {
      if (event.target === this.cable) {
        this.save();
        this.render();
        return;
      }
      const checkbox = event.target.closest('[data-connector]');
      if (!checkbox) return;
      if (this.pending) {
        this.render();
        return;
      }
      const next = checkbox.checked ? checkbox.dataset.connector : bare;
      if (next === 'XT60 installed' && !this.twelveAwg) {
        checkbox.checked = false;
        return;
      }
      this.notice('');
      if (this.preview || this.quote) {
        this.selection = next;
        this.save();
        this.render();
        return;
      }
      const candidate = this.variantFor(next);
      if (!candidate || (next !== bare && !candidate.available)) {
        this.notice(this.dataset.unavailable);
        this.render();
        return;
      }
      const native = this.form.querySelector('[data-drone-native-option]');
      const select = native?.querySelector('select');
      const radio = Array.from(native?.querySelectorAll('input[type="radio"]') || []).find(input => this.optionText(input) === next);
      if (select) {
        const option = Array.from(select.options).find(option => option.textContent.trim() === next);
        if (option) {
          select.value = option.value;
          this.changeCombination();
          return;
        }
      } else if (radio) {
        radio.checked = true;
        this.changeCombination();
        return;
      }
      this.notice(this.dataset.unavailable);
      this.render();
    }
    guard(event) {
      if (this.quote || (!this.pending && !(this.preview && this.selected))) return;
      if (event.type === 'submit' || event.target.closest('buy-button, [type="submit"], .shopify-payment-button')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
    render() {
      for (const input of this.form.querySelectorAll('[data-connector-pending-disabled]')) {
        input.disabled = input.dataset.connectorPendingDisabled === 'true';
        delete input.dataset.connectorPendingDisabled;
      }
      if (this.selection !== 'XT60 installed' && this.querySelector('[data-connector-notice]').textContent === this.dataset.locked) this.notice('');
      if ((this.preview || this.quote) && this.selection === 'XT60 installed' && !this.twelveAwg) {
        this.selection = bare;
        this.save();
        this.notice(this.dataset.cleared);
      }
      const native = this.form.querySelector('[data-drone-native-option]');
      if (native) native.hidden = true;
      for (const checkbox of this.querySelectorAll('[data-connector]')) {
        const name = checkbox.dataset.connector;
        const candidate = this.preview ? this.variant : this.variantFor(name);
        checkbox.checked = this.selection === name;
        checkbox.disabled = Boolean(this.pending) || (!this.quote && !candidate?.available && !checkbox.checked) || (name === 'XT60 installed' && !this.twelveAwg);
        if (!this.preview && !this.quote) {
          const base = this.variantFor(bare);
          const fee = candidate && base ? candidate.price - base.price : null;
          this.querySelector(`[data-connector-fee="${name}"]`).textContent = fee === null ? this.dataset.unavailable : this.dataset.feeTemplate.replace(/\{\{\s*price\s*\}\}/g, this.money(fee));
        }
      }
      if (!this.preview && !this.quote && this.cableIndex >= 0) {
        for (const input of this.form.querySelectorAll(`input[data-option-position="${this.cableIndex + 1}"]`)) {
          if (!/(?:^|\s\/\s)12\s*AWG(?:\s+cables)?$/i.test(this.optionText(input))) {
            if (this.selection === 'XT60 installed') {
              if (!Object.hasOwn(input.dataset, 'droneCableDisabled')) input.dataset.droneCableDisabled = String(input.disabled);
              input.disabled = true;
            } else if (Object.hasOwn(input.dataset, 'droneCableDisabled')) {
              input.disabled = input.dataset.droneCableDisabled === 'true';
              delete input.dataset.droneCableDisabled;
            }
          }
        }
        const cableSelect = this.form.querySelector(`select[data-option-position="${this.cableIndex + 1}"]`);
        for (const option of cableSelect?.options || []) {
          if (!/(?:^|\s\/\s)12\s*AWG(?:\s+cables)?$/i.test(option.textContent.trim())) {
            if (this.selection === 'XT60 installed') {
              if (!Object.hasOwn(option.dataset, 'droneCableDisabled')) option.dataset.droneCableDisabled = String(option.disabled);
              option.disabled = true;
            } else if (Object.hasOwn(option.dataset, 'droneCableDisabled')) {
              option.disabled = option.dataset.droneCableDisabled === 'true';
              delete option.dataset.droneCableDisabled;
            }
          }
        }
        if (this.selection === 'XT60 installed' && this.querySelector('[data-connector-notice]').hidden) this.notice(this.dataset.locked);
      }
      const summary = this.querySelector('[data-connector-summary]');
      const total = this.querySelector('[data-connector-total]');
      summary.hidden = !this.selected;
      total.hidden = !this.selected || this.quote;
      if (this.quote) {
        summary.textContent = this.dataset.quoteSummary.replace(/\{\{\s*price\s*\}\}/g, this.money(fees[this.selection] || 0));
        for (const { link, original } of this.quoteLinks) {
          const url = new URL(original);
          const lines = [];
          if (this.cable?.value) lines.push(`Requested power leads: ${this.cable.value}`);
          if (this.selected) lines.push(`Requested connector: ${this.selection} (+${this.money(fees[this.selection])} per pack)`, 'Please confirm the complete build and quote.');
          if (lines.length) url.searchParams.set('body', lines.join('\n'));
          link.setAttribute('href', lines.length ? url.toString() : original);
        }
      } else {
        const price = (this.variant?.price || 0) + (this.preview ? (fees[this.selection] || 0) : 0);
        const quantity = Math.max(1, Math.floor(Number(this.form.querySelector('[name="quantity"]')?.value) || 1));
        summary.textContent = this.dataset.unitTemplate.replace(/\{\{\s*price\s*\}\}/g, this.money(price));
        total.textContent = this.dataset.totalTemplate.replace(/\{\{\s*quantity\s*\}\}/g, quantity).replace(/\{\{\s*price\s*\}\}/g, this.money(price * quantity));
      }
      for (const input of this.form.querySelectorAll('[data-option-position]')) {
        if (this.pending) {
          if (!Object.hasOwn(input.dataset, 'connectorPendingDisabled')) input.dataset.connectorPendingDisabled = String(input.disabled);
          input.disabled = true;
        }
      }
      const blocked = Boolean(this.pending) || (this.preview && !this.quote && this.selected);
      this.setAttribute('aria-busy', String(Boolean(this.pending)));
      this.form.toggleAttribute('data-drone-connector-blocked', blocked);
      const button = this.form.querySelector('.product-form__add-button');
      if (button) {
        if (blocked) {
          if (!button.dataset.droneOriginalText) button.dataset.droneOriginalText = button.textContent;
          button.disabled = true;
          button.textContent = this.pending ? this.dataset.updating : this.dataset.previewButton;
        } else if (button.dataset.droneOriginalText) {
          button.textContent = button.dataset.droneOriginalText;
          delete button.dataset.droneOriginalText;
          button.disabled = !this.variant?.available;
        }
      }
    }
  }
  if (!customElements.get('drone-connector-option')) customElements.define('drone-connector-option', DroneConnectorOption);
})();
  } catch(e) { console.error(e); }
})();

})();
